function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.854,
    height: 17.7,
    viewBox: "0 0 17.854 17.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "tag (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40492",
    d: "m2.485 11.525 5.986 5.985a1.67 1.67 0 0 0 2.362 0L18 10.348V2H9.656L2.485 9.171a1.67 1.67 0 0 0 0 2.354z",
    transform: "translate(-1 -1.15)",
    style: {
      fill: "none",
      stroke: "#015fe5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8",
    transform: "translate(12.822 5.024)",
    style: {
      fill: "none",
      stroke: "#015fe5",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.7px"
    },
    d: "M.008 0H0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.f4a25323c6c62ac8badd64ce3da44dd9.svg";
export { ForwardRef as ReactComponent };